<template>
  <div>
    <v-app-bar
      flat
      class="menu-toolbar"
      :class="{ 'menu-toolbar-logged-in': isLoggedIn }"
      color="white"
    >
      <v-toolbar-title class="menubar-title">
        <router-link to="/lead-provider" class="logo-link">
          <div v-if="whitelabel.cssLogo" class="internal-logo-css-only" />
        </router-link>
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        v-if="isLoggedIn"
        rounded
        depressed
        outlined
        color="primary"
        @click="logout"
        >Log out</v-btn
      >
    </v-app-bar>
  </div>
</template>

<script>
import { mdiMenu } from "@mdi/js";
import { LOGOUT_MUTATION } from "../../constants/graphql/authentication";

export default {
  name: "NavBar",
  data() {
    return {
      icons: {
        mdiMenu: mdiMenu,
      },
    };
  },
  methods: {
    logout() {
      const id = this.userId;
      this.$apollo
        .mutate({
          mutation: LOGOUT_MUTATION,
          variables: { id },
        })
        .then(() => {
          this.$store.dispatch("logout");
          this.$router.push("/");
        });
    },
    menuItems() {
      return this.loggedInItems;
    },
  },
};
</script>

<style lang="scss">
@import "../../constants/styles/mixins.scss";
</style>
